export function errorDetail(data: unknown): string {
    const detail = (data as { detail?: unknown }).detail;
    return detail === undefined ? '' : `:  ${detail}`;
}
